import React from 'react';
import { useNavigate } from 'react-router-dom';
import './pages.css';

const Blogs = () => {
  const navigate = useNavigate();

  // Function to navigate to blog post
  const openBlogPost = (post) => {
    navigate(`/blog/${encodeURIComponent(post.title)}`);
  };
  const blogPosts = [
    {
      title: "Ranking Redwood City Cafes Until I Go Broke",
      excerpt: "The Baker Next Door, Philz Coffee, Cafe Stellato, Coffebar, Con Azucar Cafe, etc.",
      category: "Food & Life"
    },
    {
      title: "Ranking Broadway Musicals",
      excerpt: "Wicked, Hadestown, Hell's Kitchen, Moulin Rouge, Hamilton, SIX, Chicago, Operation Mincemeat, Great Gatsby",
      category: "Entertainment"
    },
    {
      title: "Life Milestones",
      excerpt: "Maid of Honor Speech, Planning Stacey's Surprise Bachelorette, Toronto Half Marathon, AGG Team Canada, Skydiving, Half Marathon #2",
      category: "Personal"
    },
    {
      title: "Short Thoughts",
      excerpt: "Really miscellaneous",
      category: "Miscellaneous"
    }
  ];

  return (
    <div className="page-container">
      <div className="blogs-header">
        <h1>Thoughts & Blogs</h1>
        <p className="blogs-subtitle">Anything & Everything!</p>
      </div>
      
      <div className="blogs-content">
        {blogPosts.map((post, index) => (
          <article 
            key={index} 
            className="blog-post"
            style={{cursor: 'pointer'}}
            onClick={() => openBlogPost(post)}
          >
            <div className="blog-post-header">
              <h2 className="blog-title">{post.title}</h2>
            </div>
            <p className="blog-excerpt">{post.excerpt}</p>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Blogs; 